import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, Inject, Injector, LOCALE_ID, NgModule} from '@angular/core';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AppLayoutModule} from './layout/app.layout.module';
import {MessageService} from "primeng/api";
import {HttpInterceptorService} from "./services/http_interceptor.service";
import {HTTP_INTERCEPTORS, HttpClient} from "@angular/common/http";
import {appInitializerFactory} from "./factory/app_initializer_factory";
import {
  TranslateModule,
  TranslateLoader,
  TranslateService
} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {SafeUrlPipe} from './services/safe-url.pipe';
import {BrowserModule} from "@angular/platform-browser";
import { DragulaModule } from 'ng2-dragula';

export function TranslateLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    AppLayoutModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserModule,
    DragulaModule.forRoot()
  ],
  declarations: [
    AppComponent,
    SafeUrlPipe
  ],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    {provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true},
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, Injector],
      multi: true
    },
    MessageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private translate: TranslateService, @Inject(LOCALE_ID) locale: string) {
  
  }
}
